export default "__VITE_ASSET__79c90693__"